module.exports = __webpack_public_path__ + "assets/img/mecha-detail-btn-2edb0746.png";